import { client } from '@generated/subscription-service/client.gen';
import { getAuthToken } from '@auth/session-storage';
import { config } from '@config';

export const SUBSCRIPTION_SERVICE_URL = config.subscriptionServiceUrl;

client.setConfig({
    baseUrl: SUBSCRIPTION_SERVICE_URL,
    auth: () => getAuthToken() ?? '',
});

export { client as subscriptionServiceClient };
